import React from "react";
import { Helmet } from "react-helmet-async";

function Seo({
    title,
    description,
    path = "/",
    image = "/android-chrome-512x512.png",
    keywords = "",
}) {
    const siteName = "Dahlia Health Care Services";
    const baseUrl = "https://www.dahlia-healthcareservices.co.uk";
    const canonical = `${baseUrl}${path}`;
    const fullTitle = title ? `${title} | ${siteName}` : siteName;
    const fullImage = image.startsWith("http") ? image : `${baseUrl}${image}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords ? <meta name="keywords" content={keywords} /> : null}
            <link rel="canonical" href={canonical} />
            <meta name="robots" content="index, follow" />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={fullImage} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={fullImage} />
        </Helmet>
    );
}

export default Seo;